import dateUtils from '@/utils/dateUtils';

export function cleanQueryParams(params) {
    const ret = { ...params };

    for (let key in ret) {
        if (ret[key] === null || ret[key] === undefined || ret[key] === '') {
            delete ret[key];
        }
    }

    return ret;
}

export function normalizeQueryParams(data) {
    const ret = { ...data };

    ret.startDate = ret.startDate && dateUtils.dateUtilsFormatQueryParam(ret.startDate);
    ret.endDate = ret.endDate && dateUtils.dateUtilsFormatQueryParam(ret.endDate);

    return cleanQueryParams(ret);
}
